import type { CorrectComponentType } from "../utils/index";
import { type Path } from "./makePathContextHooks";
import type { BaseOptions } from "./internal/types";

export const makePathDataArrayItemComponent = <
  RootData = any,
  Props extends { itemIndex: Path<RootData> } = any,
>({
  hooks,
  name,
}: BaseOptions<RootData, Props>): CorrectComponentType<Props> => {
  const { usePath, provide } = hooks;
  return (props, { element }) => {
    if (!props.itemIndex)
      return console.warn(`${name}: No path attribute provided.`);

    const fullPath = usePath({
      path: () => props.itemIndex,
      element,
    });

    provide({
      element,
      path: fullPath,
    });
  };
};
